import { render, staticRenderFns } from "./datSnackbar.vue?vue&type=template&id=6111a9b8"
import script from "./datSnackbar.vue?vue&type=script&lang=js"
export * from "./datSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports